import BaseResource from './index'
import validators from '../utilities/validation'

function validateTitle(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Title'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateFirstName(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'First Name'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateLastName(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Last Name'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateUsername(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Username'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateEmail(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Email'
        throw validationError + '(' + validationError.field + ')'
    }
}

export default class UserResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/users'

    static validation = {
        title: validateTitle,
        first_name: validateFirstName,
        last_name: validateLastName,
        username: validateUsername,
        email: validateEmail,
    }
}
